import React, { useMemo } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { getRandomLoadingMessage } from "../constants/funnyMessages.js";

type LoadingPawSize = "xxs" | "xs" | "sm" | "md" | "lg";

interface LoadingPawProps {
  message?: string;
  size?: LoadingPawSize;
  className?: string;
  showMessage?: boolean;
  inline?: boolean;
}

const LOADING_PAW_SRC = "/assets/gifs/catPawLoading.lottie";

function sizeToPx(size: LoadingPawSize) {
  switch (size) {
    case "xxs":
      return 32;
    case "xs":
      return 56;
    case "sm":
      return 120;
    case "lg":
      return 260;
    default:
      return 180;
  }
}

const LoadingPaw: React.FC<LoadingPawProps> = ({
  message,
  size = "md",
  className = "",
  showMessage = true,
  inline = false,
}) => {
  const randomMessage = useMemo(() => getRandomLoadingMessage(), []);
  const displayMessage = message ?? randomMessage;
  const px = sizeToPx(size);

  return (
    <div
      data-testid="loading-paw"
      data-loading-message={displayMessage}
      className={`${
        inline
          ? "inline-flex items-center justify-center"
          : "flex flex-col items-center justify-center"
      } ${className}`}
    >
      <DotLottieReact
        src={LOADING_PAW_SRC}
        autoplay
        loop
        style={{ width: px, height: px }}
      />
      {showMessage && displayMessage && (
        <p className={`${inline ? "ml-2" : "mt-2"} text-gray-700 text-center`}>
          {displayMessage}
        </p>
      )}
    </div>
  );
};

export default LoadingPaw;
